var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgH1LandlinePhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.89 15a5.75 5.75 0 00-5.47-4h-7.67a5.76 5.76 0 00-5.49 4H13v35.85c-.7 1.78-1.57 4-2.56 6.59-1.72 4.45-.62 7.5.61 9.28A10 10 0 0029 61.32V58h1.25a5.76 5.76 0 005.49-4H65V15H35.89zM25 61.09v.25a5.92 5.92 0 01-10.6 3.32c-1-1.43-1-3.36-.18-5.61.73-1.88 1.39-3.58 2-5h1.08a5.72 5.72 0 005.46 4H25v3.04zm7-8.82A1.72 1.72 0 0130.27 54h-7.54A1.72 1.72 0 0121 52.27V16.73A1.72 1.72 0 0122.73 15h7.54A1.72 1.72 0 0132 16.73v35.54zM45 49h-4v-4h4v4zm0-7h-4v-4h4v4zm0-7h-4v-4h4v4zm7 14h-4v-4h4v4zm0-7h-4v-4h4v4zm0-7h-4v-4h4v4zm7 14h-4v-4h4v4zm0-7h-4v-4h4v4zm0-7h-4v-4h4v4zm0-9H41v-6h18v6z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/H1_Landline_phone.cf0f9ac5.svg";
export { SvgH1LandlinePhone as ReactComponent };